module.exports = __webpack_public_path__ + "static/media/voix5.bc8e49af.ogg";